<div class="dg-modal-header">
    <h2>{{ uploadConfig.title }}</h2>
    <i (click)="cancel()"
       (keydown.enter)="cancel()"
       tabindex="0"
       role="button"
       class="close-icon icon-cross_16px">
    </i>
</div>

<div class="dg-modal-body">
    <div
        class="upload-warning-block"
        *ngIf="uploadConfig.warning"
        [innerHTML]="uploadConfig.warning | safe: 'html'"
    ></div>
    <ui-file-upload
        [newFileName]="newFileName"
        [areaTitle]="uploadConfig.areaTitle"
        [customRestrictions]="uploadConfig.customRestrictions"
        [resolvedExtensions]="uploadConfig.formats"
        [maxSizePerFile]="uploadConfig.maxFileSize"
        [recommendedDimensions]="uploadConfig.recommendedDimensions || {}"
        [errors]="uploadConfig.errors || {}"
        [isVisitorRequest]="isVisitorRequest"
        [isAttachment]="isAttachment"
        [isVisitorBulkUpload]="uploadConfig.isBulkVisitorUpload"
        [isCleBulkUpload]="uploadConfig.isCleUpload"
        [isExtension]="isExtension"
        [requestCategoryId]="uploadConfig.requestCategoryId"
        [employeeFunctionId]="employeeFunctionId"
        (uploaded)="uploaded($event)"
        (bulkVisitorFileUploaded)="uploaded($event)"
    ></ui-file-upload>
</div>
<div class="dg-modal-footer">
    <button
        id="cancel-upload-photo"
        appTrackClickButton
        type="button"
        class="button secondary"
        [disabled]="isDeleteRequestActive"
        (click)="cancel()"
    >Cancel
    </button>

    <button
        id="save-upload-photo"
        appTrackClickButton
        type="button"
        class="button primary"
        [disabled]="upload.data.length===0 || isDeleteRequestActive"
        (click)="save()"
    >{{ uploadConfig.button }}
    </button>
</div>
